import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'math-equal-greater', 'MathEqualGreater', [["path",{"d":"M5 18l14 -4","key":"svg-0"}],["path",{"d":"M5 14l14 -4l-14 -4","key":"svg-1"}]]);